import { Component } from '@angular/core';

@Component({
	selector: 'g-payment-cancelled',
	templateUrl: './payment-cancelled.component.html',
	styleUrls: ['./payment-cancelled.component.scss'],
	standalone: false,
})
export class PaymentCancelledComponent {}
